// Deterministic, sequence-aware pick. The seed hashes to a starting offset
// (so picks differ across messages); `index` then walks linearly so consecutive
// rows of the same kind get distinct variants before the array wraps around.
// Use this when several rows in one response should each get a different
// variant — passing `index = 0` reproduces the simple "stable pick by seed"
// behavior.
export function pickInSequence({
  items,
  seed,
  index,
}: {
  items: readonly string[];
  seed: string;
  index: number;
}): string {
  if (items.length === 0) return '';
  let h = 0;
  for (let i = 0; i < seed.length; i++) {
    h = ((h << 5) - h + seed.charCodeAt(i)) | 0;
  }
  return items[(Math.abs(h) + index) % items.length];
}
